appstlePdpIconMove();

function appstlePdpIconMove() {
  let moved = false;

  function moveIconRow() {
    if (moved) return true;
    let iconRow = document.getElementById('appstle-custom-pdp-icon-row');
    let target = document.querySelector('.appstle_subscription_wrapper');

    if (iconRow && target) {
      target.appendChild(iconRow);
      iconRow.style.display = 'block';
      iconRow.style.margin = '20px 0';
      if (iconRow.children[0]) iconRow.children[0].classList.add('capt-l-medium');
      moved = true;
      if (typeof window.appstleUpdatePriceDescriptions === 'function') {
        window.appstleUpdatePriceDescriptions();
      }
      return true;
    }
    return false;
  }

  function moveBundleMakerAppstleBeforeSubmit() {
    let bundleForms = document.querySelectorAll('.bundle-maker-form');
    bundleForms.forEach(function (bundleForm) {
      let submitEl = bundleForm.querySelector('.bundle-maker-form__submit');
      let appBlocks = bundleForm.querySelector('.bundle-maker-form__app-blocks');
      if (submitEl && appBlocks && appBlocks.nextElementSibling !== submitEl) {
        submitEl.parentNode.insertBefore(appBlocks, submitEl);
      }
    });
  }

  function moveStandardProductAppstleBeforeSubmit() {
    let appBlocks = document.querySelectorAll('.product__block.standard__app');
    appBlocks.forEach(function (block) {
      if (block.closest('.bundle-maker-form')) return;
      if (!block.querySelector('.appstle_sub_widget, .appstle_subscription_widget, [class*="appstle"]')) return;
      let formWrapper = block.closest('.form__wrapper');
      if (!formWrapper) return;
      let form = formWrapper.querySelector('form[data-product-form]');
      if (!form) return;
      let submitHolder = form.querySelector('.product__submit__holder');
      if (!submitHolder) return;
      if (form.contains(block)) return;
      form.insertBefore(block, submitHolder);
    });
  }

  function runMoves() {
    moveBundleMakerAppstleBeforeSubmit();
    moveStandardProductAppstleBeforeSubmit();
    moveIconRow();
  }

  function observe() {
    runMoves();

    let observer = new MutationObserver(function () {
      moveBundleMakerAppstleBeforeSubmit();
      moveStandardProductAppstleBeforeSubmit();
      moveIconRow();
      if (typeof window.appstleUpdatePriceDescriptions === 'function') {
        window.appstleUpdatePriceDescriptions();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
}